export default __webpack_public_path__ + "static/media/mock1.b3d44e40.png";